(ns quuppa.qsm.register-qpe.events
  (:require [re-frame.core :as rf]))

(rf/reg-event-fx
  :qsm/revoke-authorized
  (fn [_ [_ qpe-identity]]
    {:fx [[:dispatch [:confirm/open {:message "Please confirm your revoke action? A new installation token will be generated to re-install the QPE."
                                     :ok-label "Revoke"
                                     :on-confirm [:qsm/req-forget-authorized qpe-identity]}]]]}))

(rf/reg-event-fx
  :qsm/req-forget-authorized
  (fn [_ [_ qpe-identity]]
    {:fx [[:server-dispatch {:event      [:qsm/req-forget-authorized {:identity qpe-identity}]
                             :on-success [:qsm/req-forget-authorized-done qpe-identity]
                             :on-error   [:qsm/req-forget-authorized-failure]}]]}))

(rf/reg-event-fx
  :qsm/req-forget-authorized-done
  (fn [_ [_ _qpe-identity]]
    {:fx [[:dispatch [:nav/push-state :qpes]]
          [:dispatch [:confirm/close]]
          [:dispatch [:qpe-register/close-register-sidebar]]]}))

(rf/reg-event-fx
  :qsm/req-forget-authorized-failure
  (fn [_ [_ resp]]
    {:fx [[:dispatch [:notifications/notify resp]]
          [:dispatch [:confirm/close]]]}))

(rf/reg-event-fx
  :qpe/refresh-installation-token
  (fn [_ [_ id]]
    {:fx [[:server-dispatch {:event      [:qpe/refresh-installation-token {:id id}]
                             :on-success [:qpe/refresh-installation-token-success]
                             :on-error   [:qpe/register-qpe-failed "Failed to refresh installation token"]}]]}))

(rf/reg-event-db
  :qpe/refresh-installation-token-success
  (fn [db [_ {:keys [installation-token expires_at expired]}]]
    (-> db
        (assoc-in [:register-qpe-form :data :expires_at] expires_at)
        (assoc-in [:register-qpe-form :data :expired] expired)
        (assoc-in [:register-qpe-form :data :installation-token] installation-token))))

(rf/reg-event-fx
  :qpe/register-qpe
  (fn [_ [_ {:keys [data]}]]
    {:fx [[:server-dispatch {:event      [:qpe/register-qpe data]
                             :on-success [:qpe/register-qpe-submit-success :new]
                             :on-error   [:qpe/register-qpe-failed "Failed to register QPE"]}]]}))

(rf/reg-event-fx
  :qpe/delete-qpe-registration
  (fn [_ [_ qpe-id]]
    {:fx [[:server-dispatch {:event      [:qpe/delete-qpe-registration {:id qpe-id}]
                             :on-success [:qpe/register-qpe-submit-success :delete]
                             :on-error   [:qpe/register-qpe-failed "Failed to delete QPE registration"]}]]}))

(rf/reg-event-fx
  :qpe/register-qpe-submit-success
  (fn [{:keys [db]} [_ mode new-value]]
    (case mode
      ;; When new qpe is submitted, go the delete form (same as when selecting token from the table)
      ;; & update form data with created values (id etc.)
      :new {:db (-> db
                    (assoc-in [:register-qpe-form :mode] :delete)
                    (assoc-in [:register-qpe-form :error] nil)
                    (update-in [:register-qpe-form :data] merge new-value))}
      ;; When qpe is deleted, just close the form.
      :delete {:db (dissoc db :register-qpe-form)
               :fx [[:dispatch [:confirm/close]]]})))

(rf/reg-event-db
  :qpe/register-qpe-failed
  (fn [db [_ message handler-err]]
    (assoc-in db [:register-qpe-form :error] {:message message
                                              :data handler-err})))

;;
;; QPE register sidebar
;;

(rf/reg-event-db
  :qpe-register/set-register-qpe-form-field
  (fn [db [_ ks v]]
    (assoc-in db (into [:register-qpe-form] ks) v)))

(rf/reg-event-fx
  :qpe-register/add-new-qpe
  (fn [{:keys [db]} _]
    {:db (assoc db :register-qpe-form {:data  nil
                                       :mode  :new
                                       :error nil})
     :fx [[:dispatch [:qsm/get-available-release-channels]]]}))

(rf/reg-event-fx
  :qpe-register/edit-qpe
  (fn [{:keys [db]} [_ qpe]]
    {:db (assoc db :register-qpe-form {:data qpe
                                       :mode :edit
                                       :error nil})
     :fx [[:dispatch [:qsm/get-available-release-channels]]]}))

(rf/reg-event-fx
  :qpe-register/delete-qpe-intent
  (fn [{:keys [db]} [_ qpe]]
    {:db (assoc db :register-qpe-form {:data qpe
                                       :mode :delete
                                       :error nil})}))

(rf/reg-event-db
  :qpe-register/close-register-sidebar
  (fn [db _]
    (dissoc db :register-qpe-form)))
